import { Outlet } from 'react-router-dom';

function AdminPageLayout() {
    return (
        <Outlet />
    );
}

export default AdminPageLayout;